import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiHeroMidFullImage' })(
  ({ breakpoints, typography }) => ({
    heroSection: {
      backgroundSize: `cover`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      height: typography.pxToRem(375),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(319),
        maxHeight: typography.pxToRem(252),
        backgroundPosition: 'right',
      },
    },
  })
);

export default useStyles;
